/**
 * TypeScript mirror of the backend Pydantic schemas.
 * Keep in sync with backend/app/api/v1/schemas/.
 */

export interface ConversionOptions {
  include_images: boolean;
  ocr_enabled: boolean;
  ocr_language: string;
  heading_heuristic: boolean;
  preserve_tables: boolean;
}

export const DEFAULT_OPTIONS: ConversionOptions = {
  include_images: true,
  ocr_enabled: false,
  ocr_language: "eng",
  heading_heuristic: true,
  preserve_tables: true,
};

export interface ConversionResult {
  job_id: string;
  filename: string;
  page_count: number;
  markdown: string;
  word_count: number;
  images_found: number;
  ocr_pages: number[];
  warnings: string[];
  duration_ms: number;
  created_at: string;
}

export type JobStatus =
  | "pending"
  | "processing"
  | "completed"
  | "failed"
  | "cancelled";

export interface JobError {
  error_code: string;
  message: string;
  page: number | null;
}

export interface JobCreated {
  job_id: string;
  status: "pending";
  poll_url: string;
  estimated_seconds: number | null;
}

export interface JobStatusResponse {
  job_id: string;
  status: JobStatus;
  progress: number;
  created_at: string;
  updated_at: string;
  result: ConversionResult | null;
  /** Presigned S3 URL to fetch the result when it was too large to inline. */
  result_url: string | null;
  error: JobError | null;
  expires_at: string;
}

export interface ErrorResponse {
  error_code: string;
  message: string;
  detail: Record<string, unknown> | null;
}
